import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TreeComponent, TreeModel, TreeNode, TREE_ACTIONS } from 'angular-tree-component';

import * as _ from 'lodash';

import { MenuQuery } from '@shared/queries';
import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { Sort, Language, ParseObject, Menu, MenuNode } from '@shared/data';
import { CrudService, LanguageService } from '@shared/services';
import { AlertService } from '@shared/modules/alert';
import { LoadingService } from '@shared/modules/loading';

import { EditMenuComponent } from './../edit-menu';

@Component({
  moduleId: 'module.id',
  selector: 'menu-list',
  styles: [require('./menu-list.component.scss')],
  template: require('./menu-list.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class MenuListComponent implements OnInit {
  @ViewChild('tree')
  public tree: TreeComponent;

  public menu: Menu;

  public error: Parse.Error;

  public options = {
    childrenField: 'children',
    allowDrag: true,
    allowDrop: true,
    actionMapping: {
      mouse: {
        drop: (tree:TreeModel, node:TreeNode, $event:any, {from, to}) => {
          TREE_ACTIONS.MOVE_NODE(tree, node, $event, {from, to});
          this.save();
        }
      }
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private languageService: LanguageService) {

  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.fetchMenu();
    });
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onAdd(node?: TreeNode) {
    let modelRef = this.modalService.open(EditMenuComponent);
    let component = modelRef.componentInstance as EditMenuComponent;

    component.node = new MenuNode();
    component.parent = node ? node.data : null;

    modelRef.result.then(
      result => {
        if (node) {
          node.data.children.push(result);
          this.tree.treeModel.update();
        } else {
          this.menu.children.push(result);
          this.tree.treeModel.update();
        }

        this.save();
      },
      error => 0
    );
  }

  public onSelect(node: TreeNode) {
    let modelRef = this.modalService.open(EditMenuComponent);
    let component = modelRef.componentInstance as EditMenuComponent;

    component.node = node.data;

    modelRef.result.then(
      result => {
        this.save();
      },
      error => 0
    );
  }

  public onDelete(node: TreeNode, parent: TreeNode, index: number): void {
    this.alertService.showDeleteWarning().then(
      result => {
        if (node.level == 1) {
          this.menu.children.splice(index, 1);
          this.tree.treeModel.update();
        } else {
          parent.data.children.splice(index, 1);
          this.tree.treeModel.update();
        }

        this.save();
      }
    )
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private save() {
    this.loadingService.continue();

    this.menu.save().then(
      result => {
        this.loadingService.complete();
      },
      error => {
        this.error = error;
      }
    )
  }

  private fetchMenu(): void {
    let lang = this.languageService.defaultLang;
    let query = new MenuQuery().equalTo(Menu.NAME_KEY, Menu.ROOT_NAME)

    this.loadingService.continue();

    query.first().then(
      result => {
        this.menu = result;
        this.loadingService.complete();
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+menu/menu-list/menu-list.component.ts